module.exports = __webpack_public_path__ + "static/Trimex-Outdoor-Media-Kit-2026-5441965b378839fd79a9704013f78419.pdf";